<template>
  <div class="d-flex flex-column h-100">
    <header class="masthead mb-auto">
      <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
        <div class="container">
          <a class="navbar-brand" href="/#/">
            <img src="../../assets/img/logo.png" alt="Logo" />
          </a>
          <div class="my-2 my-lg-0">
            <button
              class="btn btn-light btn-sm my-2 my-sm-0"
              @click="gotoSingin"
            >
              Login
            </button>
          </div>
        </div>
      </nav>
    </header>
    <div class="flex-shrink-0 py-5 d-flex flex-column bg-grey200">
      <section class="inner container ">
        <div class="center-contain pt-5 text-lg-center text-sm-left">
          <h1 class="pricing-heading">Select payment method</h1>
          <p class="label-text my-4">
            Your subscription starts as soon as you set up payment.
          </p>
          <h5 class="my-4 label-text"><strong>Cancel online anytime </strong></h5>
          <small class="my-2 label-text">Secure Server <i class="fa fa-lock"></i></small>
        </div>
      </section>
      <section class=" pb-0">
        <div class="container">
          <div class="row justify-content-center my-3">
            <div class="col-md-8">
              <div
                class="card method"
                v-for="(plan, index) in paymentList"
                :key="index"
              >
                <div
                  class="card-body"
                  @click="showCardByCountry(plan.paymentProvider,plan.title)"
                >
                  <ul class="d-flex list-unstyled m-0">
                    <li>
                      <img
                        v-if="plan.paymentProvider != 'manual'"
                        src="../../assets/img/card.svg"
                      />
                      <img v-else src="../../assets/img/museum.svg" />
                    </li>
                    <li>{{ plan.title }}</li>
                    <li>
                      <div class="d-flex">
                        <span
                          v-for="(img, index) in plan.thumbnails"
                          :key="index"
                        >
                          <span
                            v-if="plan.paymentProvider != 'manual'"
                            class="img pointer"
                            ><img v-bind:src="img" class="img"
                          /></span>
                        </span>
                      </div>
                    </li>
                    <li class="ml-auto"><i class="fa fa-angle-right"></i></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="py-5">
            <p class="text-lg-center text-sm-left pt-4 label-text">Download App</p>
            <p class="text-lg-center text-sm-left ">
              <img
                src="../../assets/img/google-play.png"
                alt=""
                class="cursor-pointer"
                @click="gotoAppStore('google')"
              />
              <img
                src="../../assets/img/app-store.png"
                class="ml-2 cursor-pointer"
                alt=""
                @click="gotoAppStore('apple')"
              />
            </p>
          </div>
        </div>
      </section>
    </div>
    <footer class="footer text-dark mt-auto py-3 bg-grey200">
      <div class="container text-lg-center text-sm-left">
        <a href="/#/">Home</a>
        <a href="/#/cookiesprivacy">Privacy Policy</a>
        <a href="/#/terms">Terms of Use</a>
        <a href="/#/faqs">FAQ</a>
      </div>
      <div class="footer-copyright text-lg-center text-sm-left py-2">
        Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "SelectPaymentDsp",
  components: {},
  created() {
       this.$store.commit("showPopup", false);
    this.$store.commit("showdefaultFooter", false);
    this.$store.commit("showdefaultnav", false);
    this.config = this.$store.getters.getGlobalConfigs;
    this.getSubsById(this.$route.params.pid);
    const countrycode = this.$store.getters.getGlobalConfigs.country_code;
    var list = this.$store.getters.getGlobalConfigs.payment_options;
    var countryList = JSON.parse(list);
    for (let index = 0; index < countryList.options.length; index++) {
      const CountryWhiteListed = countryList.options[index].countries.find(
        (arr) => {
          if (countrycode == arr) {
            this.paymentOptionList = countryList.options[index].paymentOptions;
            return true;
          } else {
          }
        }
      );
    }
    if (this.paymentOptionList == null) {
      this.paymentList = countryList.default
    } else {
      this.paymentList = this.paymentOptionList;
    }
  },
  computed: {
    showFlutterWave() {
      return this.$store.getters.isCountryWhiteListed;
    },
    showDpo() {
      return this.$store.getters.isCountryDpoWhiteListed;
    },
    showStripe() {
      return this.$store.getters.isCountryStripeWhiteListed;
    },
    showBraintree() {
      return this.$store.getters.isCountryBraintreeWhiteListed;
    },
  },
  methods: {
    gotoAppStore(type) {
      if (type == "google") {
        window.open(
          "https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
          "_blank"
        );
      } else if (type == "apple") {
        window.open(
          "https://apps.apple.com/gm/app/ibakatv/id1060646446",
          "_blank"
        );
      }
    },

    getSubsById(pid) {
      this.packages = this.$store.state.packages;
      this.currentPackageObj = this.packages.find((ele) => ele.id == pid);
      return this.currentPackageObj;
    },

    setBraintreeCard() {
      this.$router.push(
        "/payment/" + this.$route.params.sid + "/" + this.$route.params.pid
      );
    },
    setCard() {
      this.$router.push(
        "/stripepayment/" +
          this.$route.params.sid +
          "/" +
          this.$route.params.pid
      );
    },
    openFlutterWave() {
      this.$router.push(
        "/flutterwavepayment/" +
          this.$route.params.sid +
          "/" +
          this.$route.params.pid
      );
    },
    setCash() {
      this.$router.push(
        "/cashpayment/" + this.$route.params.pid + "/" + this.$route.params.sid
      );
    },
    gotoSingin() {
      this.$router.push("/signup");
    },

    showCardByCountry(provider,title) {
      if (provider == "stripe") {
        this.$router.push(
          "/stripecheckout/" +
            this.$route.params.sid +
            "/" +
            this.$route.params.pid
        );
      } else if (provider == "flutterwave") {
        
        let path= "/flutterwavepayment/" +
            this.$route.params.sid +
            "/" +
            this.$route.params.pid
            if(title=="Pay with Card"){
              path= path+ "?recurringType=recurring"
            }
            else if(title=="Pay with others"){
              path= path+ "?recurringType=onetime"
            }
        this.$router.push(
         path
        );
      } else if (provider == "braintree") {
        this.$router.push(
          "/checkout/" + this.$route.params.sid + "/" + this.$route.params.pid
        );
      } else if (provider == "dpo") {
        this.$router.push(
          "/process-dpo/" +
            this.$route.params.sid +
            "/" +
            this.$route.params.pid
        );
      } else if (provider == "manual") {
        this.$router.push(
          "/cashpayment/" +
            this.$route.params.pid +
            "/" +
            this.$route.params.sid
        );
      }
    },
  },

  data() {
    return {
      showforgotpasswordErr: false,
      forgotpasswordErr: "",
      isActive: false,
      doforgotpassword: true,
      userid: "",
      password: "",
      bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
      config: null,
      packages: null,
      currentPackageObj: null,
      paymentList: null,
	  paymentOptionList:null
    };
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.card-body {
  cursor: pointer;
}
.card-body:hover,
.card-body:focus {
  border-radius: 10px;
  border-color: #679f3d !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(149, 209, 76, 0.596) !important;
  box-shadow: 0 0 0 0.2rem rgba(144, 206, 69, 0.61) !important;
}

.py-5 {
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
  min-height: 100vh;
}
</style>
